<template>
  <div>
    <!--Display who is logged in-->
    <v-toolbar flat dark>
      <v-list>
        <v-list-item>
          <v-list-item-title class="subtitle-1 pl-4 font-weight-bold">{{fullName}} - Admin</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-toolbar>
    <v-list>
      <!--Pages within admin page-->
      <template v-for="item in adminItems">
        <!--If - This is a page and belongs to a group (type group)-->
        <v-list-group :key="item.title" v-if="item.type == 'group'">
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{item.title}}</v-list-item-title>
            </v-list-item-content>
          </template>
          <!--Then Iterate through the content of the group, to display the pages within-->
          <template v-for="content in item.content">
            <v-list-item :key="content.text" :to="content.link" style="background-color: #F0EFEF; padding-left:5em;">
              <v-list-item-action class="mr-0 mr-4">
                <v-icon>{{ content.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content class="ml-0 pl-0">
                <v-list-item-title>{{ content.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
        <!--Else - This do not belong to a group, and will be a standalone (no dropdown)-->
        <v-list-item v-else :key="item.text" :to="item.link" style="background-color: FCF8F8;">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content >
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      routename: "",
      value: "false",
      scrolled: false,
      drawer: { visible: null, clipped: false },
      adminItems:[
        {
          title: "",
          type: '',
          icon: "",
          link: "/front",
          text: "To the front page",
          color:"red"
        },
        {
          title: "",
          type: '',
          icon: "",
          link: "/admin/dashboard",
          text: "Dashboard"
        },
        { 
          title: "Rapporter",
          type: 'group',
          content: [
            { icon: "fas fa-user", text: "Rapport Admin", link: "/admin/report" },
          ]
        },
        { 
          title: "Brukere",
          icon: "fas fa-user",
          type: 'group',
          content: [
            { icon: "fas fa-table", text: "Bruker Admin", link: "/admin/users" },
          ]
        },
        { 
          title: "Statistikk",
          type: 'group',
          icon: "fas fa-chart-line",
          iconColor:"blue",
          content: [
            { icon: "fas fa-chart-bar", text: "Hovedside", link: "/admin/statistics" },
            { icon: "fas fa-user", text: "Brukere", link: "/admin/statisticsUsers" },
            { icon: "fas fa-book", text: "Artikkler", link: "/admin/statisticsArticles" },
            { icon: "fas fa-globe", text: "Demografi", link: "/admin/statisticsDemography" },
          ],
        },
        {
          title: "",
          type: '',
          icon: "",
          link: "/admin/interestTags",
          text: "Interesse tag"
        },
        {
          title: "",
          type: '',
          icon: "",
          link: "/admin/geoTags",
          text: "Geo Tag"
        },
        { 
          title: "Log Out",
          type: '',
          icon: "fas fa-sign-out-alt",
          text: "Log out",
          link: { name: "logout" }
        },
      ],
    };
  },
  methods: {
    ...mapMutations(["HISTORY_REMOVE"]),
    goToHistory() {
      this.$router.push(this.getHistory);
      this.HISTORY_REMOVE();
    },
    checkRouteName(name) {
      return this.routename == name;
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0;
    }
  },
  computed: {
    ...mapGetters(["getHistory", "fullName"])
  },
  mounted() {
    this.routename = this.$route.name;
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>